import "./App.css";
import HomeText from "./HomeText";
import MainPhoto from "./Main_Photo";
import useHashScroll from "./HashScroll";
import Marquee from "./components/Marquee";
import About from "./About";

function App() {
  useHashScroll();
  return (
    <div className="App">
      <Marquee />
      <MainPhoto />
      <div id="about">
        <About />
      </div>
      <HomeText />
    </div>
  );
}

export default App;
